/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Router} from '@angular/router';
import { AppConfig } from '../../app.config';
export interface User {
  email: string;
  password: string;
}
@Injectable()
export class AuthService {

  constructor (private http: HttpClient, private router: Router, private api: AppConfig) {

  }

  login (data) {
    console.log(data);
    return this.http.post<User>(this.api.baseUrl + '/user/login' , data , this.api.jsonHeaders);
  }

  impersonation (data) {
    return this.http.post<User>(this.api.baseUrl + '/user/impersonation' , data , this.api.jsonTokenHeaders);
  }

  loginBack (data) {
    return this.http.post<User>(this.api.baseUrl + '/user/loginBack' , data , this.api.jsonTokenHeaders);
  }

  getApi() {
    return this.http.get('https://api64.ipify.org?format=json');
  }

  addLoginError(userIP) {
    return this.http.get(this.api.baseUrl + '/adminLogin/adminLogin?userIP=' + userIP, this.api.jsonHeaders);
  }

  checkError(userIP) {
    return this.http.get(this.api.baseUrl + '/adminLogin/checkError?userIP=' + userIP, this.api.jsonHeaders);
  }

  clearError(userIP) {
    return this.http.get(this.api.baseUrl + '/adminLogin/clearError?userIP=' + userIP, this.api.jsonHeaders);
  }




   setSession (authResult) {
    const expiresAt = moment().add(authResult.expiresIn , 'second');

    localStorage.setItem('accessToken' , authResult.accessToken);
    localStorage.setItem('expiresIn' , JSON.stringify(expiresAt.valueOf()));

    // if (authResult.role === 'superAdmin') {
    //   localStorage.setItem('SuperAdmin' , 'true');
    // }
    //  if (authResult.role === 'user') {
    //    localStorage.setItem('user' , 'true');
    //  }
  }

  logout () {
    localStorage.clear();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('expiresIn');
    localStorage.removeItem('impersonation');
    this.api.setAuthToken(null);
    return this.router.navigate(['/pages/auth/login']);
  }

  public isLoggedIn () {
    return moment().isBefore(this.getExpiration());
  }

  isLoggedOut () {
    return !this.isLoggedIn();
  }

  getExpiration () {
    const expiration = localStorage.getItem('expiresIn');
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }
}
